import PropTypes from "prop-types";
import React from "react";
import { Policies } from "../../views";
import {
  PolicyDetails,
  SetPrerequisites
} from "../../views/Content/Policies/PolicyDetails";
import { Route } from "react-router-dom";
import {
  adminPolicies,
  policyDetails,
  policyDetailsVersions,
  policyDetailsAssignments,
  policyDetailsExclusions,
  policyDetailsSettings,
  policyVersion,
  policyVersionDetails,
  addNewPolicyDocument,
  policySetPrereqs
} from "../../routes/AdminRoutes";
import { fetchUser } from "../../redux/actions/userActions";
import { connect } from "react-redux";
import usePermissions from "../../redux/selectors/usePermissions";
import PolicyVersion from "../../views/Content/Policies/PolicyVersion/PolicyVersion";
import PolicyEditor from "../../views/Content/Policies/PolicyEditor/PolicyEditor";

export function AdminContentPolicies(props) {
  const { canManageContent } = usePermissions();

  return (
    <>
      <Route
        exact={canManageContent}
        path={adminPolicies}
        component={Policies}
      />
      {canManageContent && (
        <>
          <Route
            exact
            path={[
              policyDetails,
              policyDetailsVersions,
              policyDetailsAssignments,
              policyDetailsExclusions,
              policyDetailsSettings
            ]}
            component={PolicyDetails}
          />
          <Route path={policySetPrereqs} component={SetPrerequisites} />
          <Route
            exact
            path={[policyVersion, policyVersionDetails]}
            component={PolicyVersion}
          />
          <Route exact path={addNewPolicyDocument} component={PolicyEditor} />
        </>
      )}
    </>
  );
}

const mapStateToProps = state => ({
  userState: state.userState
});

const mapDispatchToProps = {
  fetchUser
};

AdminContentPolicies.propTypes = {
  match: PropTypes.any
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminContentPolicies);
